export default __webpack_public_path__ + "static/media/nada-button-alone.0bdcd830.png";